import styled from 'styled-components';
import {
  SkeletonHeader,
  SkeletonPage,
  SkeletonSurface
} from 'components/Skeleton/styled';

export const PageWrapper = styled(SkeletonPage).attrs({})``;

export const HeroArea = styled(SkeletonHeader).attrs({})``;

export const MetricGrid = styled.div.attrs({})`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 991px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 575px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const MetricItem = styled(SkeletonSurface).attrs({})`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const HeroGrid = styled.div.attrs({})`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 991px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 767px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
